"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[633],{

/***/ 67244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);



var AssetsProvider = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() | module-providers-layout */[__webpack_require__.e(122), __webpack_require__.e(895), __webpack_require__.e(790), __webpack_require__.e(294)]).then(__webpack_require__.bind(__webpack_require__, 28054));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(28054)];
    }
  }
});
var DrawersProvider = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() | module-providers-layout */[__webpack_require__.e(122), __webpack_require__.e(895), __webpack_require__.e(790), __webpack_require__.e(294)]).then(__webpack_require__.bind(__webpack_require__, 43928));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(43928)];
    }
  }
});
var ThemeProvider = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() | module-providers-layout */[__webpack_require__.e(122), __webpack_require__.e(895), __webpack_require__.e(790), __webpack_require__.e(294)]).then(__webpack_require__.bind(__webpack_require__, 59159));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(59159)];
    }
  }
});
var BaseStructure = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() | module-components-baseStructure */[__webpack_require__.e(662), __webpack_require__.e(714), __webpack_require__.e(122), __webpack_require__.e(609), __webpack_require__.e(557), __webpack_require__.e(895), __webpack_require__.e(186), __webpack_require__.e(790), __webpack_require__.e(272), __webpack_require__.e(959), __webpack_require__.e(849), __webpack_require__.e(427)]).then(__webpack_require__.bind(__webpack_require__, 22333));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(22333)];
    }
  }
});

var LayoutProvider = function LayoutProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(ThemeProvider, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(AssetsProvider, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(DrawersProvider, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(BaseStructure, {
          children: children
        })
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (LayoutProvider);

/***/ })

}]);